import { api } from "./api";

export const GET_ALL_CUSTOMERS = async () => {
    const { data } = await api.get("/customers")
    return data.customers || [];
}

export const GET_CUSTOMER = async (id: string) => {
    const { data } = await api.get(`/customers/${id}`)
    return data;
}

export const DELETE_CUSTOMER = async (id: string) => {
    const { data } = await api.delete(`/customers/${id}`)
    return data;
}

export const CREATE_CUSTOMER = async (params: any) => {
    const { data } = await api.post(`/customers`, params)
    return data;
}

export const UPDATE_CUSTOMER = async (id: string, params: any) => {
    const { data } = await api.patch(`/customers/${id}`, params)
    return data;
}

